<template>
  <div>
    <el-dialog title="线下面试邀请" custom-class="invitation_dialog" :visible.sync="dialogValue" width="520px" :before-close="handleClose">
      <div class="form_content">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="面试类型" prop="resource">
            <el-radio-group v-model="ruleForm.resource">
              <el-radio :label="1">线下面试</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="招聘职位" prop="interview_position">
            <el-select popper-class="priamry_select" v-model="ruleForm.interview_position" placeholder="请选择招聘职位">
              <el-option v-for="item in positionOption" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="面试地点" prop="address_id">
            <el-select popper-class="priamry_select" :popper-append-to-body='false' v-model="ruleForm.address_id" placeholder="请选择地址" @visible-change="openAddressSelect" @change="getDetialAddress">
              <el-option v-for="item in work_location" :key="item.id" :label="item.province+item.city+item.district+item.address" :value="item.id">
              </el-option>
            </el-select>
            <!-- <el-input v-model="ruleForm.interview_address"></el-input> -->
          </el-form-item>
          <el-form-item label="备注事项" prop="interview_remark">
            <el-input type="textarea" v-model="ruleForm.interview_remark" maxlength="140" show-word-limit></el-input>
          </el-form-item>
          <el-form-item label="面试时间" prop="date1">
            <el-col :span="11">
              <el-form-item prop="date1">
                <el-date-picker value-format="yyyy-MM-dd" type="date" placeholder="选择日期" v-model="ruleForm.date1" style="width: 100%;" :picker-options="pickerOptions"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col class="line" style="text-align: center;" :span="2">-</el-col>
            <el-col :span="11">
              <el-form-item prop="date2">
                <el-time-picker placeholder="选择时间" value-format="HH:mm:ss" format="HH:mm:ss" v-model="ruleForm.date2" style="width: 100%;"></el-time-picker>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item label="联系人" prop="interview_contact_id" class="org_class">
            <el-select popper-class="select_box" v-model="ruleForm.interview_contact_id" placeholder="请选择" style="width: 240px" ref="selectRef">
              <el-option v-for="item in contactData" :key="item.id" :label="`${item.name}  ${item.phone}`" :value="item.id"></el-option>
              <div class="button_report">
                <div class="no_data" v-if="contactData.length==0">暂无数据</div>
                <el-button type="text" @click="handleEdit" style="color: #685ef5;">
                  添加联系人
                </el-button>
              </div>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div class="footer_box">
        <el-button class="button" @click="handleClose">取消</el-button>
        <el-button class="button primary_button" @click="confirmInvitation('ruleForm')">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="添加联系人" custom-class="invitation_dialog" :visible.sync="phoneDialog" width="520px" :before-close="handleDialogClose">
      <div class="form_content">
        <el-scrollbar>
          <el-form :model="phoneRuleForm" :rules="phoneRules" ref="phoneRuleForm" class="demo-ruleForm">
            <div class="phone_item" v-for="(item,index) in phoneRuleForm.addPhoneData" :key="index">
              <el-form-item label="" :prop="'addPhoneData[' + index + '].name'" :rules="phoneRules.name" style="width: 120px;">
                <el-input v-model="item.name" placeholder="联系人姓名"></el-input>
              </el-form-item>
              <el-form-item label="" :prop="'addPhoneData[' + index + '].phone'" :rules="phoneRules.phone" style="flex: 1;">
                <el-input v-model="item.phone" placeholder="联系人电话">
                  <i v-if="index!=0" slot="suffix" class="el-input__icon el-icon-delete" @click="deletePhone(index)"></i>
                </el-input>
              </el-form-item>
            </div>
          </el-form>
        </el-scrollbar>
        <div class="add_button" @click="addPhone">添加联系人</div>
      </div>
      <div class="footer_box">
        <el-button class="button" @click="handleDialogClose">取消</el-button>
        <el-button class="button primary_button" @click="confirmAdd('phoneRuleForm')">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "",
  props: ["dialogValue", "id", "position_id"],
  data() {
    return {
      ruleForm: {
        resource: 1,
        id: this.id, //投递ID/面试ID
        interview_position: "",
        interview_address: "", //面试地址
        interview_time: "", //面试时间
        interview_contact_id: null, //公司联系人ID
        date1: "",
        date2: "",
        interview_remark: "", //备注事项
        address_id: null,
        position_id: this.position_id,
      },
      rules: {
        interview_position: [
          { required: true, message: "请选择职位", trigger: "change" },
        ],
        address_id: [
          { required: true, message: "请选择面试地址", trigger: "change" },
        ],
        date1: [{ required: true, message: "请选择日期", trigger: "change" }],
        date2: [{ required: true, message: "请选择时间", trigger: "change" }],
        interview_contact_id: [
          { required: true, message: "请选择联系人", trigger: "change" },
        ],
      },
      contactData: [
        {
          label: "林先生 1869563125",
          value: 1,
        },
      ],
      getParams: {
        page: 1,
        page_size: 10,
        paging: 1,
        position_type: "",
        recruitment_type: 0,
        status: 0,
        keyword: "",
      },
      positionOption: [],
      phoneDialog: false,
      phoneRuleForm: {
        addPhoneData: [
          {
            name: "",
            phone: "",
          },
        ],
      },
      phoneRules: {
        name: [
          { required: true, message: "请输入联系人姓名", trigger: "blur" },
          { min: 2, max: 10, message: "长度在 2 到 10个字符", trigger: "blur" },
        ],
        phone: [
          { required: true, message: "请输入联系人电话", trigger: "blur" },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "请输入正确的手机号码",
            trigger: "blur",
          },
        ],
      },
      work_location: [],
      pickerOptions: {
        disabledDate(time) {
          const date = new Date();
          date.setDate(date.getDate() - 1);
          return time.getTime() < date.getTime();
        },
      },
    };
  },
  mounted() {
    this.getList();
    this.getPhoneList();
    this.getAddress();
  },
  methods: {
    handleClose() {
      this.$emit("closeDrawer");
    },
    getList() {
      this.$httpcompany.axiosGetBy(
        this.$api.positionManagePositionList,
        this.getParams,
        (res) => {
          if (res.code == 200) {
            this.positionOption = res.data.list;
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        }
      );
    },
    getAddress() {
      this.$httpcompany.axiosGet(this.$api.companyAddress, (res) => {
        if (res.code == 200) {
          this.work_location = res.data ? res.data : [];
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },
    openAddressSelect(val) {
      if (val) {
        if (this.work_location.length == 0) {
          this.$message.warning("请先添加地址");
        }
      }
    },
    getDetialAddress(val) {
      let obj = this.work_location.find((item) => item.id == val);
      this.ruleForm.interview_address =
        obj.province + obj.city + obj.district + obj.address;
    },
    handleEdit() {
      this.phoneDialog = true;
      this.phoneRuleForm.addPhoneData =
        this.contactData.length == 0
          ? [
              {
                name: "",
                phone: "",
              },
            ]
          : this.contactData;
    },
    handleDialogClose() {
      this.phoneDialog = false;
      this.$emit("closeDrawer");
    },
    deletePhone(index) {
      this.phoneRuleForm.addPhoneData.splice(index, 1);
    },
    addPhone() {
      this.phoneRuleForm.addPhoneData.push({
        name: "",
        phone: "",
      });
    },
    getPhoneList() {
      this.$httpcompany.axiosGet(
        this.$api.positionManageCompanyContactList,
        (res) => {
          if (res.code == 200) {
            this.contactData = res.data.list;
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        }
      );
    },
    confirmAdd(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = {
            contact: this.phoneRuleForm.addPhoneData,
          };
          this.$httpcompany.axiosPost(
            this.$api.positionManageSaveCompanyContact,
            params,
            (res) => {
              if (res.code == 200) {
                this.$message.success("添加成功");
                this.phoneDialog = false;
                this.phoneRuleForm.addPhoneData = [];

                this.getPhoneList();
              } else {
                this.$message({
                  type: "error",
                  message: res.message,
                });
              }
            }
          );
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    confirmInvitation(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = {
            ...this.ruleForm,
          };
          params.interview_time = this.ruleForm.date1 + this.ruleForm.date2;
          params.id = this.id;
          params.position_id = this.position_id;
          delete params.date1;
          delete params.date2;
          delete params.resource;
          this.$httpcompany.axiosPost(
            this.$api.positionManageInterviewInvitation,
            params,
            (res) => {
              if (res.code == 200) {
                this.$refs[formName].resetFields();
                this.$message.success("邀请成功");
                this.$emit("closeDrawer");
                this.$emit("updateList");
              } else {
                this.$message({
                  type: "error",
                  message: res.message,
                });
              }
            }
          );
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>
<style lang='scss' scoped>
.form_content {
}
.footer_box {
  display: flex;
  justify-content: flex-end;
  .button {
    width: 90px;
    height: 34px;
    background: #ffffff;
    border-radius: 4px 4px 4px 4px;
    border: 1px solid #685ef5;
    font-weight: 400;
    font-size: 14px;
    color: #685ef5;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .primary_button {
    background: #685ef5;
    color: #ffffff;
  }
}
.phone_item {
  display: flex;
  gap: 20px;
}
.add_button {
  cursor: pointer;
  color: #685ef5;
}
.el-icon-delete {
  cursor: pointer;
  color: #685ef5;
}
::v-deep .el-input__inner {
  &:focus {
    border-color: #685ef5 !important;
  }
}
::v-deep .el-textarea__inner {
  &:focus {
    border-color: #685ef5 !important;
  }
}
::v-deep .el-radio__inner {
  background: #685ef5 !important;
  border-color: #685ef5 !important;
}
::v-deep .el-radio__input.is-checked + .el-radio__label {
  color: #685ef5;
}
::v-deep .el-date-table td.current:not(.disabled) span {
  background: #685ef5 !important;
}
::v-deep .el-scrollbar__wrap {
  overflow-x: hidden;
  overflow-y: scroll;
  max-height: 200px;
  padding-bottom: 20px;
  box-sizing: border-box;
}
</style>
<style lang='scss'>
.invitation_dialog {
  border-radius: 8px;
  .el-dialog__header {
    height: 42px;
    background: linear-gradient(90deg, #f6f5ff 0%, #fbfcff 100%);
    border-radius: 8px 8px 0px 0px;
    font-weight: 400;
    font-size: 20px;
    color: #171d26;
  }
}
.priamry_select {
  .el-select-dropdown__item.selected {
    color: #685ef5;
  }
}
.select_box {
  .el-scrollbar {
    display: block !important;
    .el-scrollbar__wrap {
      overflow-x: hidden;
      overflow-y: scroll;
    }
  }
  .el-select-dropdown__item.selected {
    color: #685ef5;
  }
  .el-select-dropdown__empty {
    display: none;
  }
  .button_report {
    width: 100%;
    padding: 0 20px 10px 20px;
    box-sizing: border-box;

    .no_data {
      text-align: center;
      width: 100%;
      padding: 10px 0;
      color: #606266;
    }
  }
}
</style>
